export default __webpack_public_path__ + "static/media/evans.ba2e88ee.jpg";